module.exports = __webpack_public_path__ + "img/watermelon.4d3ad5d0.svg";